import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withTranslation } from 'react-i18next';
import queryString from 'query-string';
import * as actions from '../../store/actions';
import LoginContent from './Login/LoginContent';
import LoginForm from './Login/LoginForm';
import SignupForm from './Login/SignupForm';
import LoginAction from './Login/LoginAction';
import ForgotPassword from './Login/ForgotPassword';
import ResetPassword from './Login/ResetPassword';
import { callGET, callPOST } from '../../Utils/ApiUtil';
import * as ShipConstants from '../../Global/Constants';
// import Icons from '../../Components/Icons/Icons';
import { setUserSession, setUserAuthoritiesSession, setUserInfoSession, getCurrentProfileId, setProfileAuthoritiesSession, setProfileAuthoritiesSessionEmpty, setCurrentModuleId } from '../../Utils/UserFunctions';
import { deleteViolationsMsg, isSet } from '../../Utils/CommonFunctions';
import { isValidEmail } from '../../Utils/UserFunctions';
import CustomLoginPage from './CustomLoginPage';
// import emailField from '../../Components/Inputs/Fields/EmailField';
import { replaceAndUpdateFileLink } from '../DomainManagementContainer/DomainConfig/DomainProcessWizard/DomainProcess3';
import axios from 'axios';
import { setErrorListAction, showErrorDetailsAction } from '../../store/actions/ErrorSetupAction';
import { checkServiceWorkerUpdate } from '../../serviceWorkerUpdate';

const standardDomainName = ["localhost1","shipcrm.org"];
class LoginContainer extends Component {

	state = {
		isCustomDomain: null,
		customHtmlLoginPage: "",
		dispCont: true,
		succCont: "",
		loginSuccess: false,
		loginError: "",
		signUpButtonDisabled: true,
		forgotButtonDisabled: false,
		signUpSucess: false,
		userResponseData: null,
		loginError: null,
		violations: null,
		signUpErrorMsg: '',
		signUpSuccessMsg: '',
		signUpPasswordRules: {
			lowercase: false, //one lowercase character
			numeric: false, //one number
			uppercase: false, //one uppercase character
			minChar: false, //8 characters minimum
			specialChar: false, //one special character
		},
		loginFormFields: {
			email: {
				field: "text",
				required: true,
				title: 'Email',
				//placeHolder: "Email",
				value: '',
				classname: 'form-control emailfield',
				options: [],
				error: '',
			},
			password: {
				title: "Password",
				field: "password",
				required: false,
				//placeHolder: "Password",
				passwordShow: true,
				classname: 'form-control pr-4 passfield',
				value: '',
				options: {
					fieldId: "age",
					fieldClass: "class"
				},
				error: '',
			},
			keepLoggedIn: {
				title: "Keep Me Logged In",
				field: "checkbox",
				required: false,
				placeHolder: "",
				value: '',
				options: {
					fieldId: "age",
					fieldClass: "class"
				}
			}
		},
		signupFormFields: {
			fname: {
				title: "First Name",
				field: "text",
				required: true,
				placeHolder: "First Name",
				classname: 'form-control',
				value: '',
				options: [],
				error: '',
			},
			lname: {
				title: "Last Name",
				field: "text",
				required: true,
				placeHolder: "Last Name",
				classname: 'form-control',
				value: '',
				options: [],
				error: '',
			},
			email: {
				field: "email",
				required: true,
				title: 'Email',
				placeHolder: "Email",
				classname: 'form-control',
				value: '',
				options: [],
				error: '',
			},
			company: {
				title: "Company Name",
				field: "text",
				required: false,
				placeHolder: "Company Name",
				classname: 'form-control',
				value: '',
				options: [],
				error: '',
			},
			password: {
				title: "Password",
				field: "password",
				required: false,
				placeHolder: "Password",
				classname: 'form-control pr-4',
				value: '',
				passwordShow: true,
				options: [],
				error: '',
			},
			timeZone: {
				title: "Time Zone",
				field: "select2",
				required: false,
				placeHolder: "",
				classname: 'form-control',
				value: 'Canada/Mountain',
				options: [],
				error: '',
			},
			language: {
				title: "Language",
				field: "select",
				required: false,
				placeHolder: "",
				classname: 'form-control',
				value: '',
				options: [],
				error: '',
			},
			locale: {
				title: "Locale",
				field: "select",
				required: false,
				placeHolder: "",
				classname: 'form-control',
				value: '',
				options: [],
				error: '',
			},
			dateformat: {
				title: "Dateformat",
				field: "select",
				required: false,
				placeHolder: "",
				classname: 'form-control',
				value: '',
				options: [],
				error: '',
			},
		},
		forgotPasswordFormFields: {
			email: {
				field: "text",
				required: true,
				title: 'Email',
				//placeHolder: "Email",
				value: '',
				classname: 'form-control emailfield',
				options: [],
				error: '',
			}
		},
		resetPasswordFormFields: {
			password: {
				title: "Password",
				field: "password",
				required: false,
				placeHolder: "",
				classname: 'form-control',
				value: '',
				passwordShow: true,
				options: [],
				error: '',
			}
		},
		isFetchedDomainLogin:false,
		requestPayload:{},
		formsPayload:{},
		formsValidations:{},
		outputResponse:{},
		isApiTrackingSource:true, // Enable true for myship.ca tracking & false for shipcrm.org tracking
		secondApiCallMade: false,
		shipmentDetails: [],
		tempFormsPayload:{}
	}


	componentWillMount() {
		// my code 07 - Hide success msg, error msg existing one in both Login and Signup module
		if (this.props.show === 'login') {
			this.props.authStart();
		} else {
			this.props.signUpStart();
		}

		this.props.clearRedirectURL();
		this.getUserUtils();
	}

	componentDidMount =()=> {
		this.getApiDetails();
		
	}
	getApiDetails = (callStep = false) => {
		const { isCustomDomain, isApiTrackingSource } = this.state;
		const isStandardDomain = standardDomainName.includes(window.location.hostname);
		const fetchAndSetState = (url, stateUpdates, callback) => {
			fetch(url)
				.then(response => response.json())
				.then(jsonData => {
					this.setState({ requestPayload: jsonData, ...stateUpdates }, callback);
				})
				.catch(error => console.error('Error fetching JSON:', error));
		};
		if ((!isStandardDomain && isCustomDomain === null) || callStep) {
			if (!callStep) {
				this.getDomainLoginPage(window.location.hostname);
			}
			const fetchUrl = isApiTrackingSource && !callStep ? "/myship-api.json" : "/data.json";
			const callback = callStep
				? () => this.setState({ isApiTrackingSource: false }, () => {
					  if (callStep) this.submitTrackingHandler();
				  })
				: undefined;
			fetchAndSetState(fetchUrl, {}, callback);
		} else {
			fetchAndSetState("/myship-api.json", { isApiTrackingSource: true, secondApiCallMade: false });
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		return true;
	}

	componentDidUpdate(previousProps, previousState) {
		if ((previousProps.signUpSuccessMsg !== this.props.signUpSuccessMsg) || (previousProps.responseData !== this.props.responseData)) {
			this.clearFormHandler();
		}
		if (this.props.redirectURL !== '' && this.props.redirectURL !== null) {
			this.props.history.push('/login');
		}
	}

	getDomainLoginPage = (domainName) => {
		this.props.Loader(true);
		callGET("domain/" + domainName + "/get-login-page/")
			.then(res => {
				// console.log("GetDomainLoginPageRespose", res);
				if (res.status === 200) {
					const resData = res.data;
					if (resData.code === 200 && resData.message !== "" && resData.data !== undefined) {
						if (resData.data.custom_login_acive === true) {
							const loginHtml = replaceAndUpdateFileLink(resData.message);
							// console.log('loginHtml',loginHtml);
							this.setState({
								isFetchedDomainLogin:true,
								customHtmlLoginPage: loginHtml,
								isCustomDomain: true
							})
						} else {
							this.setState({
								isFetchedDomainLogin:true,
								isCustomDomain: false,
							})
						}

					} else {
						// this.props.failMessage(resData.message);
						this.setState({isFetchedDomainLogin:true});
						this.switchCustomLogin(false);
					}
					this.props.Loader(false);
				}
			}, (error) => {
				// console.log("Error", error);
				this.setState({isFetchedDomainLogin:true});
				this.switchCustomLogin(false);
				this.props.Loader(false);
			})
	}

	getUserUtils = () => {
		callGET("utils/timezone")
			.then(response => {
				const responseData = response.data;
				if (responseData.code === ShipConstants.API_STATUS_SUCCESS) {
					const timezoneList = [];
					if (responseData.data.length > 0) {
						responseData.data.map((arr, i) => {
							const value = {
								"value": arr.timezone_id,
								"label": arr.timezone_name,
							}
							timezoneList.push(value);
							return true;
						})
						// timezoneId = responseData.data[0].timezone_id;
					}
					const updateState = { ...this.state }
					updateState.signupFormFields['timeZone'].options = timezoneList;
					this.setState(updateState);
				}
			})
			.catch(err => {
				console.log("Connction Error============", err);
			});
	}

	loginOnChangeHandler = (event) => {
		const updateState = { ...this.state };
		updateState.loginFormFields[event.target.name].value = event.target.value;
		if (isSet(event.target.value, null) !== null) {
			let currentClassname = updateState.loginFormFields[event.target.name].classname;
			updateState.loginFormFields[event.target.name].error="";
			if (!currentClassname.includes('has-value')) {
				updateState.loginFormFields[event.target.name].classname = [currentClassname, 'has-value'].join(' ');
			}
		}
		this.setState(updateState);
	}

	select2OnChangeHandler = (value, name) => {
		const updateState = { ...this.state };
		updateState.signupFormFields[name].value = value;
		this.setState(updateState);
	}

	signupOnChangeHandler = (event) => {
		const { name, value } = event.target;
		const updateState = { ...this.state };
		const updateStatePasswordRule = updateState.signUpPasswordRules;
		if (name === 'password') {
			const passwordValue = value;

			updateStatePasswordRule.lowercase = /[a-z]/.test(passwordValue) ? true : false;
			updateStatePasswordRule.numeric = /\d/.test(passwordValue) ? true : false;
			updateStatePasswordRule.uppercase = /[A-Z]/.test(passwordValue) ? true : false;
			updateStatePasswordRule.minChar = passwordValue.length >= 8 ? true : false;
			updateStatePasswordRule.specialChar = /^[a-zA-Z0-9 ]*$/.test(passwordValue) ? false : true;
		}
		if (value === ' ') {
		} else {
			updateState.signupFormFields[name].value = value;
		}


		// // For email validation
		// if(name === 'email'){			
		// 	let validEmail = isValidEmail(value);			
		// 	if(validEmail === false){
		// 		updateState.signupFormFields[name].error= 'Enter valid email!!!';				
		// 	}else{
		// 		updateState.signupFormFields[name].error= '';	
		// 	}
		// }


		if (updateState.signupFormFields.fname.value.trim().length !== 0 && updateState.signupFormFields.company.value.trim().length !== 0 && updateState.signupFormFields.lname.value.trim().length !== 0 && updateStatePasswordRule.lowercase && updateStatePasswordRule.numeric && updateStatePasswordRule.uppercase && updateStatePasswordRule.minChar && updateStatePasswordRule.specialChar && updateState.signupFormFields.company.value && updateState.signupFormFields.email.value && updateState.signupFormFields.fname.value && updateState.signupFormFields.lname.value && updateState.signupFormFields.fname.value.trim().length !== 0 && updateState.signupFormFields.company.value.trim().length !== 0 && updateState.signupFormFields.lname.value.trim().length !== 0) {
			updateState.signUpButtonDisabled = false;

		} else {
			updateState.signUpButtonDisabled = true;
		}

		if (this.state.violations) {
			let viol = this.state.violations;
			if (name === 'company') {
				viol = deleteViolationsMsg('companyName', this.state.violations);
			} else {
				viol = deleteViolationsMsg(name, this.state.violations);
			}
			updateState['violations'] = viol;
		}

		this.setState(updateState);
	}

	forgotOnChangeHandler = (event) => {
		const updateState = { ...this.state };
		updateState.forgotPasswordFormFields[event.target.name].value = event.target.value;
		if (updateState.forgotPasswordFormFields.email.value) {
			updateState.forgotButtonDisabled = false;
		} else {
			updateState.forgotButtonDisabled = true;
		}
		this.setState(updateState);
	}

	resetOnChangeHandler = (event) => {
		const updateState = { ...this.state };
		updateState.resetPasswordFormFields[event.target.name].value = event.target.value;
		this.setState(updateState);
	}


	/*Signup*/
	forgotPasswordHandler = () => {
		const email = this.state.forgotPasswordFormFields.email.value;
		// const email = "thamizh2704@gmail.com";
		const data = {
			"email": email
		}
		const url = 'login/forgot-password';
		console.log(JSON.stringify(data), url);
		this.props.callServer(url, data);
	}

	/*Signup*/
	resetPasswordHandler = () => {
		// const password = this.state.resetPasswordFormFields.password.value;

		let params = queryString.parse(this.props.location.search);
		console.log('params', params.token);

		// const password = "thamizh2704@gmail.com";
		const password = this.state.resetPasswordFormFields.password.value;
		const data = {
			"token": params.token,
			"password": password
		}
		const url = 'login/reset-password';
		console.log(JSON.stringify(data), url);
		this.props.callServer(url, data);
	}

	passwordViewHandler = (formName, field) => {
		const updateState = { ...this.state };
		if (formName === "login") {
			updateState.loginFormFields[field].passwordShow = !this.state.loginFormFields[field].passwordShow;
		} else if (formName === "reset") {
			updateState.resetPasswordFormFields[field].passwordShow = !this.state.resetPasswordFormFields[field].passwordShow;
		} else {
			updateState.signupFormFields[field].passwordShow = !this.state.signupFormFields[field].passwordShow;
		}
		this.setState(updateState);
	}

	clearFormHandler = () => {
		console.log("clearFormHandler");
		const updateState = { ...this.state };
		if (this.props.show === "signup") {
			updateState.signUpSucess = true;
			const signupFormFields = updateState.signupFormFields;
			signupFormFields.fname.value = '';
			signupFormFields.lname.value = '';
			signupFormFields.email.value = '';
			signupFormFields.email.error = '';
			signupFormFields.company.value = '';
			signupFormFields.password.value = '';
		} else if (this.props.show === "forgotpassword") {
			updateState.forgotPasswordFormFields.email.value = "";
		} else if (this.props.show === "resetPassword") {
			updateState.resetPasswordFormFields.password.value = "";
		}
		this.setState(updateState);
	}
	switchCustomLogin = (isActive) => {
		console.log("SwitchCustomLogin");
		this.setState({
			isCustomDomain: (isActive !== undefined) ? isActive : (this.state.isCustomDomain === null) ? true : !this.state.isCustomDomain
		})
	}

	oauthSignup = (res) => {
		/*const googleresponse = {
		  Name: res.profileObj.name,
		  email: res.profileObj.email,
		  token: res.googleId,
		  Image: res.profileObj.imageUrl,
		  ProviderId: 'Google'
		};*/
		// console.log(res);
		if (res.profileObj) {
			const googleresponse = {
				company_name: res.profileObj.name,
				email: res.profileObj.email,
				//password : res.tokenObj.access_token
				password: res.googleId
			}
			//signUpOAuth
			console.log("googleresponse", googleresponse);
			this.props.signUpOAuth(googleresponse, "en");
		}
	}
	updatePayloadHandler = (payload) => {
		this.setState({
			formsPayload: { ...this.state.formsPayload,...payload},
			formsValidations:{}
		});	
	};
	onChangeHandler = (name,val)=>{
		let updateFormValidations = {...this.state.formsValidations};
		if(name==='SearchBy'){
			updateFormValidations = {};
		}
		this.setState({
			formsPayload:{
				...this.state.formsPayload,
				[name]:val
			},
			formsValidations:{
				...updateFormValidations,
				[name]:''
			}
		})
	}
	render() {
		// const {t} = this.props;
		const { isCustomDomain, customHtmlLoginPage,formsPayload,requestPayload,outputResponse } = this.state;
		// console.log('isCustomDomain',isCustomDomain,customHtmlLoginPage);
		const responseGoogle = (response) => {
			const res = response.profileObj;
			this.oauthSignup(response);
		}
		if (isCustomDomain !== null && isCustomDomain === true  && this.props.show==='login') {
			return (
				<>
					<CustomLoginPage
						{...this.state}
						{...this.props}
						formsPayload={formsPayload}
						loginOnChangeHandler={this.loginOnChangeHandler}
						onChangeHandler={this.onChangeHandler}
						submitLoginHandler={this.submitLoginHandler}
						submitTrackingHandler={this.submitTrackingHandler}
						clearTrackingHandler={this.clearTrackingHandler}
						switchCustomLogin={this.switchCustomLogin}
						updatePayloadHandler={this.updatePayloadHandler}
						htmlLoginPage={customHtmlLoginPage}
					/>
				</>
			)
		}
		if (!standardDomainName.includes(window.location.hostname) && this.state.isFetchedDomainLogin===false){
			return <></>;
		}
		return (


			<div className="login-crm">

				<div className="login_Bg"> </div>
				<div className="wrap-login">

					<div className="login100-form validate-form">
					
						{/* <div className="m_loginNav d-sm-block d-md-none"> */}
						
						{/* <div className="m_loginNav">
							<ul className="m-0  p-0 d-flex align-items-center justify-content-between">
								<li>

									<NavLink className="crm_Login" to="/login">
										<Icons iconType={'LoginIcon'} />
										<span> Login </span>
									</NavLink>
								</li>

							  	 /Temporarily disabled by faiza 
								<li>
									<NavLink className="crm_Signup svgIconFill" to="/signup">
										<Icons iconType={'SignupIcon'} />
										<span> Sign up </span>
									</NavLink>
								</li>
							 
							</ul>
						</div>
						*/}
						<div className="row" style={{justifyContent:'center'}}>

							{/*<h1>{t('Email')}</h1>*/}
							<LoginContent />
							<div className="col-md-5">
							<span className="login100-form-title pb-5">
								Login
							</span>
								{this.props.show === "login" ?
									<LoginForm formData={JSON.stringify(this.state.loginFormFields)} changed={this.loginOnChangeHandler} clicked={this.submitLoginHandler} passwordViewHandler={this.passwordViewHandler} validationError={this.state.loginError} responseGoogle={responseGoogle} signup={this.signup} />
									: this.props.show === "signup" ?
										<SignupForm formData={JSON.stringify(this.state.signupFormFields)} select2OnChangeHandler={this.select2OnChangeHandler} changed={this.signupOnChangeHandler} passwordViewHandler={this.passwordViewHandler} clicked={this.submitSignUpHandler} validationSuccess={this.state.signUpSuccessMsg} validationError={this.state.signUpErrorMsg} violations={this.state.violations} passwordRule={this.state.signUpPasswordRules} signUpButtonDisabled={this.state.signUpButtonDisabled} />
										: this.props.show === "forgotpassword" ?
											<ForgotPassword formData={JSON.stringify(this.state.forgotPasswordFormFields)} changed={this.forgotOnChangeHandler} clicked={this.forgotPasswordHandler} validationError={this.props.requestError} validationSuccess={this.props.responseData} forgotButtonDisabled={this.state.forgotButtonDisabled} />
											:
											<ResetPassword formData={JSON.stringify(this.state.resetPasswordFormFields)} changed={this.resetOnChangeHandler} clicked={this.resetPasswordHandler} validationError={this.props.requestError} validationSuccess={this.props.responseData} forgotButtonDisabled={this.state.forgotButtonDisabled} passwordViewHandler={this.passwordViewHandler} />
								}
							</div>
							<LoginAction />
						</div>
					</div>
				</div>
			</div>
		);
	}

	/*Login Authentication*/
	submitLoginHandler = () => {


		let emailVal = this.state.loginFormFields.email.value;
		let passwordVal = this.state.loginFormFields.password.value;
		let validEmail = isValidEmail(emailVal);
		const updateState = { ...this.state };
		// console.log('updateState',updateState);
		let errorCnt = 0;
		if(passwordVal===''){
			errorCnt++;
			updateState.loginFormFields.password.error = 'Password is required';
		}else if (validEmail === false) {
			errorCnt++;
			updateState.loginFormFields.email.error = 'Enter valid email';
			//updateState.signUpButtonDisabled = true;
		} 
		if(emailVal===''){
			errorCnt++;
			updateState.loginFormFields.email.error = 'Email is required';
		}
		
		
		if(errorCnt>0){
			this.setState(updateState);
			return false;
		}else{
			updateState.loginFormFields.email.error = '';
			updateState.loginFormFields.password.error = '';
			this.setState(updateState);
		}
		this.props.Loader();
		const username = ShipConstants.API_AUTORIZATION_USERNAME;
		const password = ShipConstants.API_AUTORIZATION_PASSWORD;
		const token = Buffer.from(`${username}:${password}`, 'utf8').toString('base64');

		var requestData = new FormData();
		requestData.append('username', this.state.loginFormFields.email.value);
		requestData.append('password', this.state.loginFormFields.password.value);
		// requestData.set('username', 'system@gmail.com');
		// requestData.append('password', 'system');
		requestData.append('grant_type', ShipConstants.API_GRANT_TYPE);

		// this.props.onAuth(token,requestData);
		const header = {
			'Authorization': `Basic ${token}`
		}
		checkServiceWorkerUpdate();
		// callPOST('oauth/token', requestData, header)
		const url = ShipConstants.API_URL+'oauth/token';
		axios.post(url, requestData, {
			headers: header
		  }).then(authResponse => {
				const authResponseData = authResponse.data;
				setUserSession(authResponseData);
				this.setState({ userResponseData: authResponseData })
				setTimeout(() => {
					this.getUserInfo();
				}, 100)
			})
			.catch(err => {
				console.log(err);
				if (err.response) {
					let errDisp = '';
					if (err.response.data.error) {
						errDisp = err.response.data.error;
					} else {
						errDisp = err.response.data.errors;
					}
					console.log("errror============", errDisp);
					this.props.failMessage(errDisp);
					this.setState({ loginError: errDisp });
				} else {
					const errors = ["Connection Refused. Please contact admin..."];
					console.log("Connction Error============", err);
					this.props.failMessage(errors);
					this.setState({ loginError: errors });
				}
				this.props.Loader(false);
			})
	}
	clearTrackingHandler = ()=>{
		const {formsPayload} = this.state;
		// console.log('searchBy',isSet(formsPayload['SearchBy'], null));
		this.setState({
			formsPayload:{
				SearchBy:isSet(formsPayload['SearchBy'], null)
			}
		})
	}

	submitTrackingHandler = ()=>{
		const {formsPayload,requestPayload,isApiTrackingSource ,tempFormsPayload} = this.state;
		const {mappingFields,requestJson,api_url,access_token,validationRules} = requestPayload;
		let updateValidation = {};
		let errorCount = 0;

		const searchBy = isSet(formsPayload['SearchBy'], null);
		if (isApiTrackingSource) {
			this.setState({ tempFormsPayload: { ...formsPayload } }, () => {
			});
		}
		if (validationRules[searchBy]) {
			const rules = validationRules[searchBy];

			// Required field validation
			for (const [field, message] of Object.entries(rules.fields)) {
				if (isSet(formsPayload[field], null) === null) {
					errorCount++;
					updateValidation[field] = message;
				}
			}

			// Max length validation
			for (const [field, max] of Object.entries(rules.maxLength || {})) {
				const value = isSet(formsPayload[field], '');
				if (value.toString().split(',').length > max) {
					errorCount++;
					updateValidation[field] = `Only a maximum of ${max} items is allowed for tracking at a time.`;
				}
			}
		}
		// let updateValidation ={};
		// let errorCount = 0;
		// if(isSet(formsPayload['SearchBy'],null)===null){
		// 	errorCount++;
		// 	updateValidation={
		// 		...updateValidation,
		// 		SearchBy:'Track by field is required'
		// 	}
		// }
		// if(isSet(formsPayload['SearchBy'],null)==='ORDER_ID' && isSet(formsPayload['order_ids'],null)===null){
		// 	errorCount++;
		// 	updateValidation={
		// 		...updateValidation,
		// 		order_ids:'Order Id field is required'
		// 	}
		// }
		// if(isSet(formsPayload['SearchBy'],null)==='TRACKING_NUMBER' && isSet(formsPayload['tracking_numbers'],null)===null){
		// 	errorCount++;
		// 	updateValidation={
		// 		...updateValidation,
		// 		tracking_numbers:'Tracking Number field is required'
		// 	}
		// }
		// if(isSet(formsPayload['SearchBy'],null)==='ORDER_ID' && isSet(formsPayload['order_ids'],null)===null){
		// 	errorCount++;
		// 	updateValidation={
		// 		...updateValidation,
		// 		order_ids:'Order Id field is required'
		// 	}
		// }
		// if(isSet(formsPayload['SearchBy'],null)==='REFERENCE' && isSet(formsPayload['reference_codes'],null)===null){
		// 	errorCount++;
		// 	updateValidation={
		// 		...updateValidation,
		// 		reference_codes:'Reference field is required'
		// 	}
		// }
		// if(isSet(formsPayload['SearchBy'],null)==='ORDER_ID' && isSet(formsPayload['order_ids'],'').split(',').length>5){
		// 	errorCount++;
		// 	updateValidation={
		// 		...updateValidation,
		// 		order_ids:`Only a maximum of 5 Order Id is allowed for tracking at a time.`
		// 	}
		// }
		// if(isSet(formsPayload['SearchBy'],null)==='REFERENCE' && isSet(formsPayload['reference_codes'],'').split(',').length>5){
		// 	errorCount++;
		// 	updateValidation={
		// 		...updateValidation,
		// 		reference_codes:`Only a maximum of 5 Order Id is allowed for tracking at a time.`
		// 	}
		// }
		// if(isSet(formsPayload['SearchBy'],null)==='TRACKING_NUMBER' && isSet(formsPayload['tracking_numbers'],'').split(',').length>5){
		// 	errorCount++;
		// 	updateValidation={
		// 		...updateValidation,
		// 		tracking_numbers:`Only a maximum of 5 Tracking Numbers is allowed for tracking at a time.`
		// 	}
		// }
		// if(isSet(formsPayload['SearchBy'],null)==='REFERENCE' && isSet(formsPayload['account_id'],null)===null){
		// 	errorCount++;
		// 	updateValidation={
		// 		...updateValidation,
		// 		account_id:'Customer Number field is required'
		// 	}
		// }
		
		if(errorCount>0){
			this.setState({
				formsValidations:updateValidation
			});
			return false;
		}
		this.props.Loader(true);
		let payload = {};
		
		if(isApiTrackingSource){
			Object.entries(requestJson[searchBy]).forEach(([key, value]) => {
				const keyParam = isSet(mappingFields[key],'');
				const selectedValue = isSet(formsPayload[keyParam],'');
				payload = {
					...payload,
					[key]:selectedValue
				}
			});
		}else{
			payload = requestJson.map((itm)=>{
				const keyParam = isSet(mappingFields[itm.variable_name],'');
				const selectedValue = isSet(tempFormsPayload[keyParam],'');
				return{
					...itm,
					values:[
						{
							value:(isSet(itm.type,'')!=='TextInput')?isSet(selectedValue,'').toString().split(','):isSet(selectedValue,'')
						}]
				}
			});
		}	
		const parent = document.querySelector('.viewMoreToggle');
		this.setState({
			outputResponse:{shipment_details:[]}
		})
		  if(isApiTrackingSource && !this.state.secondApiCallMade)
		  {
			this.shipmentDetails = []; 
			
		  }
		  else if(isApiTrackingSource && this.state.secondApiCallMade){  // 1nd api call execution isApiTrackingSource true && secondApiCallMade true
			this.setState(
			  {
				tempFormsPayload: {}  
			  }
			  );
		  }
		const header = {};
		const url = ShipConstants.API_URL+api_url+'?access_token='+access_token;
		axios.post(url, payload, {
			headers: header
		  }).then(res => {
				// this.props.Loader(false);
				if(res.status===200){
					const resData = res.data;
					if(resData.code===200){
						const responseData = isSet(resData.data,[]);
						let errorMessageList = [];
						if(responseData.messages!==undefined && responseData.messages.length>0){
							errorMessageList = responseData.messages;
							this.props.setErrorListAction(errorMessageList); 
							if(!this.props.isErrorModalOpen){
							  this.props.showErrorDetailsAction();
							} 
						  }
						// let shipmentDetails = null;
						let missingIds = [];
						if (responseData.length > 0) {
						  const	responseDataNew = JSON.parse(responseData);
					
						const identifierKey = payload.orderId ? "orderId" : payload.trackingNumber ? "trackingNumber" : null;
						if (!identifierKey) {
						  return;
						}
						const payloadIds = payload[identifierKey].split(",").map(id => id.trim());
						if (responseDataNew?.order && Array.isArray(responseDataNew.order)) {
						  const responseIds = responseDataNew.order.map(order => {
						  if (identifierKey === "orderId" && order["Order ID#"]) {
							return order["Order ID#"].toString();
						  } else if (identifierKey === "trackingNumber" && order["tracking_number"]) {
							return order["tracking_number"].toString();
						  } else {
							return null;
						  }
						  }).filter(id => id !== null);
						  missingIds = payloadIds.filter(id => !responseIds.includes(id));
						  if (missingIds.length > 0) {
						  const updateKey = identifierKey === "orderId" ? "order_ids" : "tracking_numbers";
						  
						  if (Object.keys(this.state.tempFormsPayload).length === 0) {
							this.setState({ tempFormsPayload: { ...formsPayload } }, () => {
							});
							}
				  
						  this.setState(prevState => ({
							tempFormsPayload: {
							  ...prevState.tempFormsPayload,
							  [updateKey]: missingIds.join(",")
							}
						  }), () => {
							this.getApiDetails(true, missingIds);
						  });
					
						  } else {
						  this.props.Loader(false);
						  }
						}
						}
						if(isApiTrackingSource){
							try{
								const parsedData = JSON.parse(responseData);
								if(parsedData && parsedData.hasOwnProperty('order')){
									parsedData.order.forEach(order => {
										// Ensure packages exist and is an array before iterating
										if (Array.isArray(order.packages)) {
										  order.packages.forEach(pkg => {
											if (typeof pkg.cf_pallet_type === "string") {
											  pkg.cf_pallet_type = {
												name: pkg.cf_pallet_type,
												value: pkg.cf_pallet_type
											  };
											}
										  });
										}
									  });
									this.shipmentDetails = Array.isArray(this.shipmentDetails) ? [...this.shipmentDetails, ...parsedData.order] : parsedData.order;
									// shipmentDetails = parsedData.order;
								}
							}catch(e){
								console.error(e);
							}
						}else{
							try {
								const variables = responseData.variables;
								const indexing = variables.findIndex((i=>i.api_name==="shipment_details"));
								const msgIndexing     = variables.findIndex(i => isSet(i.api_name,'')==="messages");
								// shipmentDetails = (indexing!==-1)?JSON.parse(variables[indexing].value):[];
								if (indexing !== -1 && variables[indexing]?.value) {
									const newShipmentDetails = JSON.parse(variables[indexing].value);
									if (Array.isArray(this.shipmentDetails)) {
									  this.shipmentDetails = [...this.shipmentDetails, ...newShipmentDetails];
									  this.props.Loader(false);
									} else {
									  this.shipmentDetails = newShipmentDetails;
									  this.props.Loader(false);
									}
									}
									else{
										this.props.Loader(false);
									}
									if (msgIndexing !== -1 && errorMessageList.length === 0) {
                                        try {
                                          errorMessageList = isSet(variables[msgIndexing].value, []);
                                          if (errorMessageList.length > 0) {
                                            this.props.setErrorListAction(errorMessageList);
                                             if (!this.props.isErrorModalOpen) {
                                             this.props.showErrorDetailsAction();
                                              }
                                            }
                                        } catch (e) {
                                             this.props.failMessage('We couldn’t locate your tracking details. Kindly review the information provided');
                                             this.props.Loader(false);
    
                                        }
                                    }
								if(msgIndexing!==-1 && errorMessageList.length===0){
									try{
									  errorMessageList =  isSet(variables[msgIndexing].value,[]);
									  if(errorMessageList.length>0){
										this.props.setErrorListAction(errorMessageList);
										if(!this.props.isErrorModalOpen){
										  this.props.showErrorDetailsAction();
										}
									  }
									}catch(e){
										this.props.failMessage('We couldn’t locate your tracking details. Kindly review the information provided');
										this.props.Loader(false);

									}
								  }
							} catch(e) {
								this.props.failMessage('We couldn’t locate your tracking details. Kindly review the information provided');
								this.props.Loader(false);

							}
						}			
						if(this.shipmentDetails!==undefined && this.shipmentDetails!==null && this.shipmentDetails.length > 0){
							this.getApiDetails();
							try{
								if(this.shipmentDetails.length===0 && errorMessageList.length===0){
									this.props.failMessage('We couldn’t locate your tracking details. Kindly review the information provided')
									this.props.Loader(false);
								}
								if(this.shipmentDetails.length>0){
									// const parent = document.querySelector('.viewMoreToggleclose');
									if(parent){
										parent.click();
									}
								}			
								this.setState({
									outputResponse:{shipment_details:this.shipmentDetails}
								})
								// console.log('responseData',values,variables,variables[indexing].value);
							}catch(e){
								// console.log('parent',parent);
								this.setState({
									outputResponse:{shipment_details:[]}
								})
								if(errorMessageList.length===0){
									this.props.failMessage('We couldn’t locate your tracking details. Kindly review the information provided')
									this.props.Loader(false);			
								}
							}
							
						}else{
							const { secondApiCallMade } = this.state;
							if (secondApiCallMade) {
								this.getApiDetails();
								this.props.failMessage('We couldn’t locate your tracking details. Kindly review the information provided');
								this.props.Loader(false);
							} else {
								this.setState({ secondApiCallMade: true, isApiTrackingSource : true }, () => {
									this.getApiDetails(true);
								});
							}
						}
					}
				}
			// console.log('APIres',res);
			})
			.catch(err => {
				this.props.Loader(false);
				console.log(err);
				if (err.response) {
					
				} else {
				}
				this.props.Loader(false);
			})
		// console.log('formsPayload',payload,formsPayload,requestPayload);
	}

	/*Get user info*/
	getUserInfo = () => {
		callGET('users/info')
			.then(reponse => {
				const responseData = reponse.data;
				if (responseData.code === ShipConstants.API_STATUS_SUCCESS) {
					setUserInfoSession(responseData);
					this.getUserAuthorities(responseData);
				} else {
					this.props.Loader(false);
				}
			})
			.catch(err => {
				console.log(err);
				this.props.Loader(false);
			})
	}

	/*Get user Authorities*/
	getUserAuthorities = (userData) => {
		callGET('users/userAuthorities')
			.then(response => {
				const responseData = response.data;
				if (responseData.code === ShipConstants.API_STATUS_SUCCESS) {
					setUserAuthoritiesSession(responseData);
					let currModId = '';
					const userDefaultMod = userData.data.user_preference.default_module;
					responseData.data.map((arr, ind) => {
						if (userDefaultMod === arr.module_name) {
							currModId = arr.id;
						}
					})
					setCurrentModuleId(currModId);
					this.getProfileAuthorities();
				} else {
					this.props.Loader(false);
				}
				console.log(response);
			})
			.catch(err => {
				console.log(err);
				this.props.Loader(false);
			})
	}

	/*Get Profile Authorities*/
	getProfileAuthorities = () => {
		const profile_id = getCurrentProfileId();
		setProfileAuthoritiesSessionEmpty()
		callGET('profiles/' + profile_id)
			.then(response => {
				const responseData = response.data;
				if (responseData.code === ShipConstants.API_STATUS_SUCCESS) {
					setProfileAuthoritiesSession(responseData);
				}
				this.props.authSucess(this.state.userResponseData);
				this.props.Loader(false);
			})
			.catch(err => {
				console.log(err);
				this.props.Loader(false);
			})
	}

	/*Signup*/
	submitSignUpHandler = () => {
		const email = this.state.signupFormFields.email.value;
		const company = this.state.signupFormFields.company.value;
		const pass = this.state.signupFormFields.password.value;
		const fname = this.state.signupFormFields.fname.value;
		const lname = this.state.signupFormFields.lname.value;
		const timeZone = this.state.signupFormFields.timeZone.value;
		const data = {
			first_name: fname,
			last_name: lname,
			company_name: company,
			email: email,
			password: pass,
			timezoneId: timeZone
		}


		let validEmail = isValidEmail(email);
		const updateState = { ...this.state };
		//const signupFormFields = updateState.signupFormFields;
		if (validEmail === false) {
			updateState.signupFormFields.email.error = 'Enter valid email!!!';
			//updateState.signUpButtonDisabled = true;
			this.setState(updateState);
			//console.log('fail')
			return false;
		} else {
			updateState.signupFormFields.email.error = '';
			//updateState.signUpButtonDisabled = false;
			this.setState(updateState);
			// console.log('pass');
			// return false;
		}


		this.props.Loader();
		callPOST('organizations/signup', data)
			.then(authResponse => {
				const responseData = authResponse.data;
				if (responseData.code === ShipConstants.API_STATUS_SUCCESS) {
					this.setState({ signUpErrorMsg: '', signUpSuccessMsg: responseData.message });
					setTimeout(() => {
						this.props.history.push("/login");
					}, 5000)
				} else if (responseData.code === ShipConstants.API_STATUS_FAIL) {
					if (responseData.violations && responseData.violations.length > 0) {
						let viol = {};
						let errMsg = '';
						if (responseData.violations) {
							responseData.violations.map((arr, ind) => {
								const data = arr.field_name + ':' + arr.message;
								viol[arr['field_name']] = arr['message'];
								errMsg += ind === 0 ? data : '<br />' + data;
							})
							this.setState({ violations: viol });
						}
					} else {
						this.setState({ signUpErrorMsg: responseData.message, signUpSuccessMsg: '' });
					}
				} else {
					this.setState({ signUpErrorMsg: responseData.message, signUpSuccessMsg: '' });
				}
				this.props.Loader(false);
			})
			.catch(err => {
				console.log(err);
				if (err.response) {
					// dispatch(signUpFail(err.response.data.errors));
					this.setState({ signUpErrorMsg: err.response.data.errors, signUpSuccessMsg: '' });
				} else {
					const errors = ["Connection Refused. Please contact admin..."];
					// dispatch(signUpFail(errors));
					this.setState({ signUpErrorMsg: errors, signUpSuccessMsg: '' });
				}
				this.props.Loader(false);
			})
		// this.props.onSignup(data,"en");
	}
}

const mapStateToProps = state => {
	return {
		authenticated: state.reducer.authenticated,
		error: state.reducer.loginError,
		signUpSuccessMsg: state.reducer.signupSucessmsg,
		signUpErrorMsg: state.reducer.signupError,
		signupviolationsErrorMsg: state.reducer.signupviolationsError,
		isErrorModalOpen:state.ErrorSetupReducer.isErrorModalOpen,    
	    errorsList:state.ErrorSetupReducer.errorsList,
		requestError: state.reducer.requestError,
		responseData: state.reducer.responseData,
		redirectURL: state.reducer.redirectURL
	};
}

const mapDispatchToProps = dispatch => {
	return {
		// onAuth: (token, body) => dispatch(actions.auth(token, body)),
		setErrorListAction:(arr)=>dispatch(setErrorListAction(arr)),
		showErrorDetailsAction:(arr)=>dispatch(showErrorDetailsAction()),
		onSignup: (body, locale) => dispatch(actions.signUp(body, locale)),
		callServer: (url, body) => dispatch(actions.callServer(url, body)),
		signUpOAuth: (body, locale) => dispatch(actions.signUpOAuth(body)),
		authStart: () => dispatch(actions.authStart()),
		signUpStart: () => dispatch(actions.signUpStart()),
		clearRedirectURL: () => dispatch(actions.clearRedirectURL()),
		authSucess: (data) => dispatch(actions.authSucess(data)),
		Loader: (msg) => dispatch(actions.loader(msg)),
		succMessage: (msg) => dispatch(actions.succMessage(msg)),
		failMessage: (msg) => dispatch(actions.failMessage(msg)),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withTranslation()(LoginContainer)));